import {setupAxios} from '../app/modules/auth'
import {API_BASE_URL} from '../utils/contants'

// form save api integration
export async function addBand(InputField: {
  bandName: string
  bandDescription: string
  minCtc: string
  maxCtc: string
}) {
  const {token, tenantId} = setupAxios()

  const res = await fetch(API_BASE_URL + `/band`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
    body: JSON.stringify({
      bandName: InputField.bandName,
      bandDescription: InputField.bandDescription,
      minCtc: InputField.minCtc,
      maxCtc: InputField.maxCtc,
    }),
  })
  return await res.json()
}

//edit by id
export async function updateBandById(
  InputField: {
    bandName: string
    bandDescription: string
    minCtc: string
    maxCtc: string
  },
  id: string
) {
  const {token, tenantId} = setupAxios()
  const res = await fetch(API_BASE_URL + `/band/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
    body: JSON.stringify({
      bandName: InputField.bandName,
      bandDescription: InputField.bandDescription,
      minCtc: InputField.minCtc,
      maxCtc: InputField.maxCtc,
    }),
  })
  return await res.json()
}

//   get Band

export async function getBands() {
  const {token, tenantId} = setupAxios()
  const res = await fetch(API_BASE_URL + `/band`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
  })
  return await res.json()
}

//   delete band

export async function deleteBands(id: string) {
  const {token, tenantId} = setupAxios()
  const res = await fetch(API_BASE_URL + `/band/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
  })
  return await res.json()
}

//getBandbyid

export async function getBandsById(userId: string | undefined) {
  const {token, tenantId} = setupAxios()
  const res = await fetch(API_BASE_URL + `/band/${userId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-tenant-Id': `${tenantId}`,
    },
  })
  return await res.json()
}
